var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithoutText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 43,
    viewBox: "0 0 33 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5275 3.8544C26.8471 3.8544 30.349 7.53448 30.349 12.0739C30.349 16.6111 26.8506 20.2901 22.5326 20.2933C18.214 20.2901 14.7142 16.6122 14.7111 12.0739H14.7061C14.7061 7.53448 18.2074 3.8544 22.5275 3.8544Z",
    fill: "url(#paint0_linear_5180_43256)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2145 0H0.980264H0.914239C0.687214 0.0346926 0.480504 0.154248 0.33017 0.336251L0.0406744 0.608454C0.0147722 0.760034 0.00105929 0.913749 4.35213e-05 1.06746C4.35213e-05 2.87681 1.93001 3.05828 1.93001 3.05828C3.04127 3.33475 3.80564 4.40595 3.74824 5.60418C3.74926 5.82301 3.72691 6.04131 3.68222 6.25533C3.51411 6.60119 3.4237 6.98228 3.41812 7.37083C3.41812 8.7959 4.94178 9.28159 4.94178 9.28159C5.77014 9.68189 6.29682 10.5551 6.28768 11.5126C6.28666 11.954 6.19829 12.39 6.02865 12.7935C5.71681 13.1858 5.53803 13.6758 5.52077 14.1866C5.52077 15.3608 6.69906 16.028 6.69906 16.028C7.26891 16.4875 7.60716 17.1947 7.61834 17.9494C7.60056 18.5749 7.40604 19.1802 7.05966 19.6894C6.56701 20.0624 6.26533 20.6527 6.24197 21.2906C6.29326 21.9513 6.58631 22.5651 7.05966 23.0038C7.41721 23.4538 7.61986 24.0185 7.63357 24.605C7.60107 25.4014 7.26586 26.1512 6.70414 26.6866C6.02357 26.9753 5.57054 27.6612 5.55124 28.4319C5.57308 28.971 5.75084 29.4903 6.05913 29.921C6.24095 30.3047 6.33948 30.7259 6.34862 31.1539C6.34862 32.6484 4.97225 33.4436 4.97225 33.4436C3.75332 33.8279 3.44859 34.6445 3.44859 35.333C3.45469 35.7264 3.53392 36.1144 3.68222 36.4752C3.74266 36.725 3.77364 36.9807 3.77364 37.2385C3.77364 39.1172 1.93001 39.6883 1.93001 39.6883C0.28446 39.8004 4.35213e-05 40.9852 4.35213e-05 41.7325C-0.000972251 41.9225 0.015788 42.112 0.0508321 42.2982L0.309854 42.5437C0.480504 42.7108 0.694324 42.8208 0.924396 42.8586H21.2195C27.626 42.8811 32.8369 37.4418 32.8583 30.7088C32.8694 27.1333 31.3864 23.7329 28.8023 21.408C33.649 17.01 34.1859 9.31575 30.0009 4.22182C27.7982 1.54035 24.5939 0 21.2241 0C21.22 0 21.2175 0 21.2145 0ZM21.9154 3.65085C26.235 3.65085 29.7368 7.33093 29.7368 11.8703C29.7368 16.4076 26.2385 20.0866 21.9205 20.0898C17.6019 20.0866 14.1021 16.4086 14.099 11.8703H14.0939C14.0939 7.33093 17.5953 3.65085 21.9154 3.65085Z",
    fill: "url(#paint1_linear_5180_43256)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8239 11.8113C24.8239 10.3318 23.6626 9.13261 22.2298 9.13261C21.7475 9.13261 21.2959 9.26853 20.909 9.5053C21.1055 9.68642 21.2292 9.94998 21.2292 10.2434C21.2292 10.7897 20.8004 11.2324 20.2714 11.2324C20.0738 11.2324 19.8903 11.1707 19.7378 11.0649C19.6713 11.3018 19.6357 11.5522 19.6357 11.8113C19.6357 13.2908 20.7971 14.49 22.2298 14.49C23.6626 14.49 24.8239 13.2908 24.8239 11.8113Z",
    fill: "#1D1D1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5180_43256",
    x1: 34.3257,
    y1: 7.98662,
    x2: 26.1523,
    y2: 0.0341168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5180_43256",
    x1: 0.319987,
    y1: -0.361856,
    x2: 0.319987,
    y2: 41.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4600DB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/logo-without-text.a2adfa4f.svg";
export { ForwardRef as ReactComponent };